/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { actions as addressesActions } from 'feature/addresses/redux/AddressSlice'
import { RootState } from 'store/types'

import { actions } from '../YandexMapSlice'
import { FIAS_LEVEL } from 'constants/const'

// двигаем карту к координатам suggest
export const moveMapBySuggestCordsAndPlaceMark = createAsyncThunk<
  void,
  void,
  { state: RootState }
>(
  'yandexMap/moveMapBySuggestCordsAndPlaceMark',
  async (_, { getState, dispatch }) => {
    try {
      const YMap = window.map
      const inputSuggest = getState().address.inputSuggest
      const zoom = getState().yandexMap.zoom
      if (inputSuggest === null) {
        return
      }
      const coords: [number, number] = [
        Number(inputSuggest.geoLat),
        Number(inputSuggest.geoLon),
      ]
      if (!coords[0] || !coords[1]) {
        dispatch(actions.setClickMarkCoords(null))
        return
      }

      if (!YMap) throw new Error('YMap instance is not available')

      // двигаемся к точке
      YMap.panTo(coords, { flying: true }).then(() => {
        // устанавливаем зум и центр карты
        YMap.setCenter(coords, zoom, { duration: 300 })
        // ставим метку
        dispatch(actions.setClickMarkCoords(coords))
        // если адрес валидный
        dispatch(
          addressesActions.setIsValidAddress(
            +inputSuggest.fiasLevel >= FIAS_LEVEL,
          ),
        )
      })
    } catch (error) {
      console.error('yandexMap/moveMapBySuggestCordsAndPlaceMark', error)
    }
  },
)
